export { default } from './CameraEmbed';
